import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import WaterTowersTopHead from './water-towers-top-head';
import WaterTowersContent from './water-towers-content';
import WaterTowersModals from './water-towers-modals';
import { actions as waterTowersActions, fetchWaterTowersWithFilters } from './store/slice';

const { resetFilters } = waterTowersActions;

const WaterTowersView = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchWaterTowersWithFilters());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => dispatch(resetFilters());
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Water Towers</h4>
              </div>
            </div>
            <WaterTowersTopHead />
          </div>
          <WaterTowersContent />
          <WaterTowersModals />
        </div>
      </div>
    </div>
  );
};

export default WaterTowersView;
